export default __webpack_public_path__ + "static/media/freezer-empty.17619e22.svg";